import { render, staticRenderFns } from "./PartnerConfirmationModal.vue?vue&type=template&id=bd3c9b04"
import script from "./PartnerConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./PartnerConfirmationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports